import { Component, ReflectiveInjector } from '@angular/core';
import { ApplicationInsightsService } from '../../_services/applicationInsights.service';
import { Adal5Service } from 'adal-angular5';
@Component({
    template: ''
})
export class BaseComponent {

    private myMonitoringService: ApplicationInsightsService;
    userEmail: string;
    ipAddr:  string;


    constructor( adalService: Adal5Service) {
		// Manually retrieve the monitoring service from the injector
		// so that constructor has no dependencies that must be passed in from child
        const injector = ReflectiveInjector.resolveAndCreate([
            ApplicationInsightsService
        ]);

        this.userEmail = adalService.userInfo.username;
        this.ipAddr = adalService.userInfo.profile.ipaddr;
        this.myMonitoringService = injector.get(ApplicationInsightsService);
        this.logNavigation(this.userEmail, this.ipAddr);

    }
    private logNavigation(email, ipaddr) {

        const properties = {
            'accountId' : email,
            'ipaddr' : ipaddr,
            'authId': email.split('@', 0)
          };

        this.myMonitoringService.logPageView(null, null, properties, null, null);
    }

    public logCustomEvent(name, properties) {
        this.myMonitoringService.logEvent(name, properties, null);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/shared/baseComponent.ts